import styled from 'styled-components';

export const Content = styled.div`
  margin-bottom: 24px;
`;

export const ButtonGrid = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;

  button {
    max-width: 120px;
  }
`;

export const DesiredItem = styled.div`
  border: none;
  cursor: default;
  margin: 10px 20px 10px 20px;
  padding: 1px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
`;

export const DesiredItemValue = styled.div`
  display: flex;
`;
